<template>
  <div class="flex flex-row justify-between mt-30 mb-15">
    <p class="heading-xs">Mobiler</p>
    <NuxtLink to="/mobiltelefoner" external>Visa alla</NuxtLink>
  </div>

  <nav class="flex flex-row flex-wrap items-center w-full gap-8">
    <AppButton
      v-for="link in links"
      :key="link.relativeUrl"
      class="w-auto basis-0 flex-grow min-w-140"
      :full-width="true"
      size="sm"
      :href="link.relativeUrl"
      :color="
        activePageLabel &&
        link.label.toLowerCase() === activePageLabel.toLowerCase()
          ? 'primary'
          : 'secondary'
      "
    >
      {{ link.label }}
    </AppButton>
  </nav>
</template>

<script lang="ts" setup>
interface Props {
  links: {
    relativeUrl: string;
    label: string;
  }[];
  activePageLabel?: string;
}
defineProps<Props>();
</script>

<style lang="scss" scoped></style>
